import { createGlobalStyle } from 'styled-components';
 
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
  }
  body.has-navbar-fixed-top {
    padding-top: 0;
  }
`;
 
export default GlobalStyle;